import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const DateRangeFilter = ({ onFilterChange, onExport, onCustomRangeChange }) => {
  const [selectedRange, setSelectedRange] = useState("7days");
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const dateRanges = [
    { id: "7days", label: "Last 7 Days", icon: "Calendar" },
    { id: "30days", label: "Last 30 Days", icon: "Calendar" },
    { id: "thisMonth", label: "This Month", icon: "CalendarDays" },
    { id: "lastMonth", label: "Last Month", icon: "CalendarDays" },
    { id: "custom", label: "Custom Range", icon: "CalendarRange" },
  ];

  const handleRangeChange = (rangeId) => {
    setSelectedRange(rangeId);
    onFilterChange(rangeId);
  };

  const handleCustomDate = (field, value) => {
    const nextFrom = field === "from" ? value : customFrom;
    const nextTo = field === "to" ? value : customTo;
    if (field === "from") setCustomFrom(value);
    else setCustomTo(value);
    if (nextFrom && nextTo && onCustomRangeChange) {
      onCustomRangeChange(nextFrom, nextTo);
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <h4 className="text-sm md:text-base font-caption font-semibold text-foreground mb-3">
            Filter by Date Range
          </h4>
          <div className="flex flex-wrap gap-2">
            {dateRanges?.map((range) => (
              <button
                key={range?.id}
                onClick={() => handleRangeChange(range?.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs md:text-sm font-caption font-semibold transition-base ${
                  selectedRange === range?.id
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground hover:bg-muted/70"
                }`}
              >
                <Icon name={range?.icon} size={14} className="md:w-4 md:h-4" />
                <span>{range?.label}</span>
              </button>
            ))}
          </div>
          {selectedRange === "custom" && (
            <div className="flex flex-wrap items-center gap-3 mt-3">
              <div className="flex items-center gap-2">
                <label className="text-xs text-muted-foreground whitespace-nowrap">From</label>
                <input
                  type="date"
                  value={customFrom}
                  max={customTo || undefined}
                  onChange={(e) => handleCustomDate("from", e.target.value)}
                  className="input text-xs py-1.5 px-2 h-auto"
                />
              </div>
              <div className="flex items-center gap-2">
                <label className="text-xs text-muted-foreground whitespace-nowrap">To</label>
                <input
                  type="date"
                  value={customTo}
                  min={customFrom || undefined}
                  onChange={(e) => handleCustomDate("to", e.target.value)}
                  className="input text-xs py-1.5 px-2 h-auto"
                />
              </div>
              {(!customFrom || !customTo) && (
                <p className="text-xs text-muted-foreground italic">Select both dates to apply filter</p>
              )}
            </div>
          )}
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            Export
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="RefreshCw"
            iconPosition="left"
            onClick={() => console.log("Refresh data")}
          >
            Refresh
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;
